import { Component, OnInit, Input, Output, EventEmitter, HostListener, ChangeDetectionStrategy, OnDestroy, ElementRef, ViewChild } from "@angular/core";
import { Router } from '@angular/router';
import { StorageService, dataStorage } from 'src/app/services/storage.service';
import { StorageEnum } from 'src/app/utilities/storage.enum';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from '../login/login.component';
import { RequestServices } from 'src/app/services/request.service';
import { Prospecto } from 'src/app/modelos/prospecto.model';
import { Contratante } from 'src/app/modelos/data-emision.model';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
import { StyleCocheSeguro } from 'src/app/modelos/styleCocheseguro.model';
import { Configuration } from 'src/app/Constants/configuration';
import { CotizacionAyudaComponent } from 'src/app/cotizacion/ayuda/cotizacion-ayuda.component';
import { CotizacionRenovacionComponent } from 'src/app/cotizacion/renovacion/cotizacion-ayuda.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InicioComponent } from "src/app/inicio/inicio.component";
import { Clipboard } from '@angular/cdk/clipboard';
@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnDestroy {
    @Input('tipoLogin') tipo: number = 0;
    datoOculto: boolean = true;
    public isMenuActive: boolean = false;
    private observableStorage: any;
    public isProfile: boolean = false;
    public profile: Profile = new Profile();
    public styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
    public const: Configuration = new Configuration();
    isMobile: boolean = false;

    @Output() productItemEvent = new EventEmitter<string>();
    @Output() quoteItemEvent = new EventEmitter<string>();
    @Output() benefitsItemEvent = new EventEmitter<string>();
    isPremier: boolean;
    isUpSivale: boolean;
    isManpower: boolean;
    isCenegas: boolean;
    isPayWithCard: boolean;
    isEmployee: boolean;
    isEmployeeSivale: boolean;
    constructor(private router: Router, private storageService: StorageService, private dialog: MatDialog,
        private requestService: RequestServices,
        private snackBar: MatSnackBar, private clipboard: Clipboard) {
        if (this.storageService.ifExist("styleCocheSeguro")) {
            this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
        }
    }

    ngOnDestroy(): void {
        this.observableStorage.complete();
        this.observableStorage.unsubscribe();
    }

    openSectionProduct = () => this.productItemEvent.emit('servicios');
    openSectionQuote = () => this.quoteItemEvent.emit('cotizador');
    openSectionBenefits = () => this.benefitsItemEvent.emit('beneficios');

    ngOnInit() {

        this.isMobile = (window.innerWidth < 1025)? true : false;

        this.isEmployee = (window.location.hostname === 'empleadoscocheseguro.inter.mx') ? true : false;
        this.isPayWithCard = (this.router.url === '/datos-tarjeta') ? true : false;
        this.isPremier = (window.location.hostname === 'cocheseguroclubpremier.inter.mx') ? true : false;
        this.isUpSivale = (window.location.hostname === 'cochesegurosivale.inter.mx') ? true : false;
        this.isManpower = (window.location.hostname === 'cocheseguromanpower.inter.mx') ? true : false;
        this.isCenegas = (window.location.hostname === 'cochesegurocenagas.inter.mx') ? true : false;

        if(this.storageService.ifExist('employeeSivale')) {
            this.isEmployeeSivale = this.storageService.getItem('employeeSivale') === 'true';
        }

        this.onMonitoreo();
        this.onValidaOpciones();
        if (this.storageService.ifExist("cocheSeguro")) {
            let cocheSeguro: CocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
            cocheSeguro.url = this.router.url;
            this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
        }
        try {
            if (sessionStorage.action) {
                delete sessionStorage.action;
                this.onLogin();
            }
        } catch (error) { }
    }


    @HostListener('window:resize', ['$event'])
    onResize(event){
      if(window.innerWidth < 1025){
        this.isMobile = true;

      }else{
        this.isMobile = false;
      }
    }

    onValidaOpciones() {
        try {
            let cocheSeguro: CocheSeguro = new CocheSeguro();
            if (this.storageService.ifExist("cocheSeguro")) {
                cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
            }
            if (cocheSeguro?.m && cocheSeguro.m !== "zl8mIfg3UrGeD1CvQu7UddMRtZ9eljnfGDTy+oOne/8=") {
                this.isProfile = true;
                try {
                    let params: any = { "a": cocheSeguro.a };
                    this.requestService.getRequest({ apiName: "InterAutosGetContratanteApi", params: params }).subscribe(result => {
                        if (result.error) {
                            console.log("error", result.error);
                        } else {
                            this.storageService.setItem('correo', result.correo);
                            this.profile.nombre = result.full_name;
                            this.profile.correo = result.correo;
                            this.profile.photo = result.avatar;
                            cocheSeguro.celular = result.celular;
                            cocheSeguro.telefono = result.telefono;
                            cocheSeguro.clEntInt = result.cliente_id;
                            cocheSeguro.cli = result.cliente_id;
                            cocheSeguro.dcl = result.direccioncliente_id;
                            cocheSeguro.sexo = (result.sexo == 1);

                            /**Datos Prospecto */
                            if (!cocheSeguro?.prospecto || cocheSeguro.prospecto === null || cocheSeguro.prospecto.nombre === "" || cocheSeguro.prospecto.correo === "" || cocheSeguro.prospecto.correo !== result.correo) {
                                cocheSeguro.prospecto = new Prospecto();
                                cocheSeguro.prospecto.nombre = result.first_name;
                                cocheSeguro.prospecto.correo = result.correo;
                                cocheSeguro.prospecto.sexo = result.sexo;
                                cocheSeguro.prospecto.cp = result.cp;
                                /**set Prospecto en Storage */
                                this.storageService.setItem('cocheSeguro', JSON.stringify(cocheSeguro), "prospecto");
                            } else if (cocheSeguro?.prospecto.logeado === false) {
                                cocheSeguro.prospecto.logeado = true;
                                this.storageService.setItem('cocheSeguro', JSON.stringify(cocheSeguro), "prospecto");
                            }
                            /**Datos Contratante */
                            if (!cocheSeguro?.contratante || cocheSeguro.contratante === null) {
                                cocheSeguro.contratante = new Contratante();
                                cocheSeguro.contratante.rfc = result.rfc;
                                cocheSeguro.contratante.nombres = result.nombres;
                                cocheSeguro.contratante.ap_pat = result.ap_pat;
                                cocheSeguro.contratante.ap_mat = result.ap_mat;
                                if (result.sexo === 1) {
                                    cocheSeguro.contratante.sexo = "M";
                                } else {
                                    cocheSeguro.contratante.sexo = "F";
                                }
                                cocheSeguro.contratante.fec_nac = result.fec_nacimiento.split("-")[2] + '-' + result.fec_nacimiento.split("-")[1] + '-' + result.fec_nacimiento.split("-")[0];
                                cocheSeguro.contratante.direccion.calle = result.calle;
                                cocheSeguro.contratante.direccion.no_ext = result.no_externo;
                                cocheSeguro.contratante.direccion.no_int = result.no_interno;
                                cocheSeguro.contratante.direccion.col = result.colonia;
                                cocheSeguro.contratante.direccion.cp = result.cp;
                                cocheSeguro.contratante.direccion.estado = result?.estado_id.toString();
                                /**set Contratante en Storage */
                                this.storageService.setItem('cocheSeguro', JSON.stringify(cocheSeguro), "contratante");
                            }
                        }
                    });
                } catch (error) {
                    console.error("error", error);
                }
            } else {
                this.isProfile = false;
                this.profile.nombre = "";
                this.profile.correo = "";
                this.profile.photo = "";
                if (!this.storageService.ifExist("cocheSeguro")) {
                    cocheSeguro.dominioMkp = "https://lb3.copsis.com"; // Variable de entorno para dominio
                    switch (window.location.hostname) {
                        case 'localhost':
                        case 'inter-autos-qa.web.app':
                        case 'inter-autos-covid-qa.web.app':
                            cocheSeguro.dominioMkp = "https://skynet.copsis.com:8181"; // Variable de entorno para dominio
                            break;
                        default:
                            cocheSeguro.dominioMkp = "https://lb3.copsis.com";
                            break;
                    }
                    cocheSeguro.m = "zl8mIfg3UrGeD1CvQu7UddMRtZ9eljnfGDTy+oOne/8="; // Base 84 = Variable de entorno para marketplace session    .
                    cocheSeguro.ntf = true; // Variable de entorno para no tiene firebase.
                    cocheSeguro.a = "0+Y4Bb5ZQpzt/bhc0/MgmnsLFlwWRXJ/cZtnrevNBPUDOtY35HUd3/xHOCo7Tyi9gDC+r5eH8g5WRgVuns8mYw=="; // Variable de entorno para mi cuenta Marketplace.
                    this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
                }
            }
        } catch (error) {
            console.error("error", error);
        }
    }

    onMonitoreo() {
        this.observableStorage = this.storageService.watchSessionStorage().subscribe((data: dataStorage) => {
            let cocheSeguro: CocheSeguro;
            if (this.storageService.ifExist("cocheSeguro")) {
                cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
            }
            switch (data.accion) {
                case StorageEnum.add:
                    if (data.key === "m") {
                        if (cocheSeguro?.m && cocheSeguro?.m !== "zl8mIfg3UrGeD1CvQu7UddMRtZ9eljnfGDTy+oOne/8=") {
                            this.onValidaOpciones();
                            if (this.router.url === '/inicio') {
                                this.onMisSeguros();
                            }
                        }
                    }
                    break;
                case StorageEnum.update:
                    if (data.key === "m") {
                        if (cocheSeguro?.m && cocheSeguro?.m !== "zl8mIfg3UrGeD1CvQu7UddMRtZ9eljnfGDTy+oOne/8=") {
                            this.onValidaOpciones();
                            if (this.router.url === '/inicio') {
                                this.onMisSeguros();
                            }
                        }
                    }
                    break;
                case StorageEnum.remove:
                    if (!this.storageService.ifExist("styleCocheSeguro")) {
                        let styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
                        switch (window.location.hostname) {
                            case "localhost":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/copsis/logo_copsis.png";
                                styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/uvm/img_bg_uvm.png)";
                                styleCocheSeguro.bgBanner = "#0e1751";
                                styleCocheSeguro.bgPrimary = "#035AA6";
                                styleCocheSeguro.bgSecondary = "#151515";
                                styleCocheSeguro.bgFooter = "#151515";
                                styleCocheSeguro.textMark = "#F57C00";
                                styleCocheSeguro.textMarkSecondary = "transparent";
                                styleCocheSeguro.colorBtn = "copsis";
                                break;
                            case "cochesegurouvm.inter.mx":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/uvm/logo_uvm.png";
                                styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/uvm/img_bg_uvm.png)";
                                styleCocheSeguro.bgBanner = "#b8b8b8";
                                styleCocheSeguro.bgPrimary = "#b8b8b8";
                                styleCocheSeguro.bgSecondary = "#b22227";
                                styleCocheSeguro.bgFooter = "#b8b8b8";
                                styleCocheSeguro.textMark = "#e72400";
                                styleCocheSeguro.textMarkSecondary = "transparent";
                                styleCocheSeguro.colorBtn = "uvm";
                                break;
                            case "cochesegurounitec.inter.mx":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/unitec/logo_unitec.png";
                                styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/unitec/bg_unitec.png)";
                                styleCocheSeguro.bgBanner = "#006fba";
                                styleCocheSeguro.bgPrimary = "#b8b8b8";
                                styleCocheSeguro.bgSecondary = "#0f406b";
                                styleCocheSeguro.bgFooter = "#006fba";
                                styleCocheSeguro.textMark = "#0f406b";
                                styleCocheSeguro.textMarkSecondary = "transparent";
                                styleCocheSeguro.colorBtn = "unitec";
                                break;
                            case "cochesegurounifin.inter.mx": case "cochesegurounifinempleados.inter.mx":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/unifin/logo_unifin.png";
                                styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/unifin/img_bg_unifin.jpg)";
                                styleCocheSeguro.bgBanner = "#00142d";
                                styleCocheSeguro.bgPrimary = "#0e1751";
                                styleCocheSeguro.bgSecondary = "#009dd0";
                                styleCocheSeguro.bgFooter = "#009dd0";
                                styleCocheSeguro.colorBtn = "inter";
                                styleCocheSeguro.textMark = "#0e1751";
                                styleCocheSeguro.textMarkSecondary = '#00b8ff';
                                break;
                            case "cochesegurolottus.inter.mx":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/lottus/logo_lottus.png";
                                styleCocheSeguro.srcBanner = "url(./assets/images/fondo-azul.png)";
                                styleCocheSeguro.bgBanner = "#00142d";
                                styleCocheSeguro.bgPrimary = "#b8b8b8";
                                styleCocheSeguro.bgSecondary = "#0f406b";
                                styleCocheSeguro.bgFooter = "#006fba";
                                styleCocheSeguro.textMark = "#0f406b";
                                styleCocheSeguro.textMarkSecondary = "transparent";
                                styleCocheSeguro.colorBtn = "unitec";
                                break;
                            case "cochesegurostone.inter.mx":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/stone/logo_stone.png";
                                styleCocheSeguro.srcBanner = "url(./assets/images/fondo-azul.png)";
                                styleCocheSeguro.bgBanner = "#00142d";
                                styleCocheSeguro.bgPrimary = "#b8b8b8";
                                styleCocheSeguro.bgSecondary = "#0f406b";
                                styleCocheSeguro.bgFooter = "#006fba";
                                styleCocheSeguro.textMark = "#0f406b";
                                styleCocheSeguro.textMarkSecondary = "transparent";
                                styleCocheSeguro.colorBtn = "unitec";
                                break;
                        }
                        this.storageService.setItem("styleCocheSeguro", JSON.stringify(styleCocheSeguro));
                    }
                    if (cocheSeguro?.m == null || cocheSeguro?.m == undefined || cocheSeguro?.m == "") {
                        this.onValidaOpciones();
                        if (this.const.PLATFORM) {
                            window.location.href = this.const.URLPLATFORM + 'inicio';
                        } else {
                            this.router.navigate(['/inicio']);
                        }
                    }
                    break;
                case StorageEnum.removeAll:
                    this.onValidaOpciones();
                    if (!this.storageService.ifExist("styleCocheSeguro")) {
                        let styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
                        switch (window.location.hostname) {
                            case "localhost":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/copsis/logo_copsis.png";
                                styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/uvm/img_bg_uvm.png)";
                                styleCocheSeguro.bgBanner = "#0e1751";
                                styleCocheSeguro.bgPrimary = "#035AA6";
                                styleCocheSeguro.bgSecondary = "#151515";
                                styleCocheSeguro.bgFooter = "#151515";
                                styleCocheSeguro.textMark = "#F57C00";
                                styleCocheSeguro.textMarkSecondary = "transparent";
                                styleCocheSeguro.colorBtn = "copsis";
                                break;
                            case "cochesegurouvm.inter.mx":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/uvm/logo_uvm.png";
                                styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/uvm/img_bg_uvm.png)";
                                styleCocheSeguro.bgBanner = "#b8b8b8";
                                styleCocheSeguro.bgPrimary = "#b8b8b8";
                                styleCocheSeguro.bgSecondary = "#b22227";
                                styleCocheSeguro.bgFooter = "#b8b8b8";
                                styleCocheSeguro.textMark = "#e72400";
                                styleCocheSeguro.textMarkSecondary = "transparent";
                                styleCocheSeguro.colorBtn = "uvm";
                                break;
                            case "cochesegurounitec.inter.mx":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/unitec/logo_unitec.png";
                                styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/unitec/bg_unitec.png)";
                                styleCocheSeguro.bgBanner = "#006fba";
                                styleCocheSeguro.bgPrimary = "#b8b8b8";
                                styleCocheSeguro.bgSecondary = "#0f406b";
                                styleCocheSeguro.bgFooter = "#006fba";
                                styleCocheSeguro.textMark = "#0f406b";
                                styleCocheSeguro.textMarkSecondary = "transparent";
                                styleCocheSeguro.colorBtn = "unitec";
                                break;
                            case "cochesegurounifin.inter.mx": case "cochesegurounifinempleados.inter.mx":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/unifin/logo_unifin.png";
                                styleCocheSeguro.srcBanner = "url(https://storage.googleapis.com/coche-seguro-inter/images/unifin/img_bg_unifin.jpg)";
                                styleCocheSeguro.bgBanner = "#00142d";
                                styleCocheSeguro.bgPrimary = "#0e1751";
                                styleCocheSeguro.bgSecondary = "#009dd0";
                                styleCocheSeguro.bgFooter = "#009dd0";
                                styleCocheSeguro.colorBtn = "inter";
                                styleCocheSeguro.textMark = "#0e1751";
                                styleCocheSeguro.textMarkSecondary = '#00b8ff';
                                break;
                            case "cochesegurolottus.inter.mx":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/lottus/logo_lottus.png";
                                styleCocheSeguro.srcBanner = "url(./assets/images/checo-background-azul.png)";
                                styleCocheSeguro.bgBanner = "#006fba";
                                styleCocheSeguro.bgPrimary = "#b8b8b8";
                                styleCocheSeguro.bgSecondary = "#0f406b";
                                styleCocheSeguro.bgFooter = "#006fba";
                                styleCocheSeguro.textMark = "#0f406b";
                                styleCocheSeguro.textMarkSecondary = "transparent";
                                styleCocheSeguro.colorBtn = "unitec";
                                break;
                            case "cochesegurostone.inter.mx":
                                styleCocheSeguro.srcLogo = "https://storage.googleapis.com/coche-seguro-inter/images/stone/logo_stone.png";
                                styleCocheSeguro.srcBanner = "url(./assets/images/checo-background-azul.png)";
                                styleCocheSeguro.bgBanner = "#006fba";
                                styleCocheSeguro.bgPrimary = "#b8b8b8";
                                styleCocheSeguro.bgSecondary = "#0f406b";
                                styleCocheSeguro.bgFooter = "#006fba";
                                styleCocheSeguro.textMark = "#0f406b";
                                styleCocheSeguro.textMarkSecondary = "transparent";
                                styleCocheSeguro.colorBtn = "unitec";
                                break;
                        }
                        this.storageService.setItem("styleCocheSeguro", JSON.stringify(styleCocheSeguro));
                    }
                    if (this.const.PLATFORM) {
                        window.location.href = this.const.URLPLATFORM + 'inicio';
                    } else {
                        this.router.navigate(['/inicio']);
                    }
                    break;
                default:
                    break;
            }
        })
    }

    onCerrarSession() {
        this.storageService.clear();
    }

    inicio() {
        this.storageService.removeItem('medioPago');
        window.location.href = "https://inter.mx";
    }

    onLogin() {
        this.dialog.open(LoginComponent);
    }

    onMisSeguros() {
        if (this.const.PLATFORM) {
            window.location.href = this.const.URLPLATFORM + 'mi-cuenta';
        } else {
            this.router.navigate(['/mi-cuenta']);
        }
    }

    OpcionMenu(event) {
        switch (event) {
            case 1:
                window.open("https://inter.mx/");
                break;
            case 2:
                window.open("https://inter.mx/servicios/");
                break;
            case 3:
                window.open("https://inter.mx/blog/");
                break;
            case 4:
                window.open("https://seguros.inter.mx/quienes-somos-2/");
                break;
        }
    }

    openWindow(event) {
        switch (event) {
            case 1:
                window.open("https://inter.mx/");
                break;
            case 2:
                window.open("https://inter.mx/promotions");
                break;
            case 3:
                window.open("https://inter.mx/blog/");
                break;
            case 4:
                window.open("https://inter.mx/about-us");
                break;
            case 5:
                window.open('https://storage.googleapis.com/coche-seguro-inter/Preguntasfrecuentes.pdf');
                break;
            case 6:
                window.open("https://inter.mx/atencion-a-clientes");
                break;
            case 7:
                window.open("https://medicoseguro.inter.mx/");
                break;
            
        }
    }

    openModalMarcame() {
        try {
            this.dialog.open(CotizacionAyudaComponent, { disableClose: false });
        } catch (error) {
            this.snackBar.open('InicioComponent.openModalMarcame().error', error, { duration: this.const.SNACK_BARTIME });
        }
    }

    onCopyToClipboard() {
        let linkToBeCopied = '';
        if (this.storageService.ifExist("logConsumoId")) {

            let logConsumoId = this.storageService.getItem('logConsumoId');
            if (logConsumoId.includes(' ')) {
                logConsumoId = logConsumoId.replace(/ /g, '+')
              }

              switch(window.location.hostname) {
                case 'inter-autos-qa.web.app':
                case 'localhost':
                    linkToBeCopied = `https://inter-autos-qa.web.app/auto-login-ayuda?logConsumoId=${logConsumoId}`;
                    break;
                case 'empleadoscocheseguro.inter.mx':
                    linkToBeCopied = `https://cocheseguro.inter.mx/auto-login-ayuda?logConsumoId=${logConsumoId}`;
                    break;
                case 'cochesegurosivale.inter.mx':
                    linkToBeCopied = `https://cochesegurosivale.inter.mx/auto-login-ayuda?logConsumoId=${logConsumoId}`;
                    break;
              }

              const result = this.clipboard.copy(linkToBeCopied);
              const message = { title: "", body: "" };

              if (result) {
                message.title = "Link copiado exitosamente al portapapeles.";
                message.body = null;
              } else {
                message.title = "Error al copiar link.";
                message.body = null;
              }
              this.snackBar.open(message.title, message.body, { duration: new Configuration().SNACK_BARTIME });
        }
    }

    validaDominio() {
        return (this.isPayWithCard) || (this.isPayWithCard && this.isEmployee) || (this.isEmployeeSivale && this.isPayWithCard);
    }
}

export class Profile {
    public nombre: string;
    public correo: string;
    public photo: string;

    constructor() { }
}
